var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationClientWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.779785C3.64 0.779785 0.90625 3.51354 0.90625 6.87354C0.90625 8.20322 1.32625 9.46666 2.12188 10.5267L6.62437 16.5908C6.63562 16.6054 6.65281 16.6111 6.66531 16.6242C6.89031 16.8651 7.215 16.8045 7.37531 16.5908C8.67188 14.8608 11.0484 11.6298 11.9622 10.411C11.9622 10.411 11.9625 10.4101 11.9628 10.4095L11.9684 10.402C12.7047 9.3676 13.0938 8.1476 13.0938 6.87354C13.0938 3.51354 10.36 0.779785 7 0.779785ZM7 10.161C5.19094 10.161 3.7125 8.6826 3.7125 6.87354C3.7125 5.06447 5.19094 3.58604 7 3.58604C8.80906 3.58604 10.2875 5.06447 10.2875 6.87354C10.2875 8.6826 8.80906 10.161 7 10.161Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationClientWhite);
export default __webpack_public_path__ + "static/media/LocationClientWhite.d3545dcc94bde1efef986564d2d16d72.svg";
export { ForwardRef as ReactComponent };